import { defineFeatures } from "../define-provider-capability";
import { staticEnvironmentValue } from "../environment-values";

/**
 * The `deploymentContext` features the mobile service selects. The app's bundle
 * carries these through `@libs/environment-client-contracts/mobile`, not the rest of
 * the capability, so a server-only change to it does not change the app.
 */
export const deploymentContextMobileFeatures = defineFeatures({
  expoPublicLissenEnv: staticEnvironmentValue(
    "EXPO_PUBLIC_LISSEN_ENV",
    "id",
    "dotenv",
    "eas-json",
  ),
  expoPublicProject: staticEnvironmentValue(
    "EXPO_PUBLIC_PROJECT_ID",
    "gcpProject",
    "eas-json",
  ),
  mobileGcpProject: staticEnvironmentValue(
    "GCP_PROJECT_ID",
    "gcpProject",
    "eas-json",
  ),
});
